export default __webpack_public_path__ + "static/media/lysningen-property-01.f4397c73.jpg";